import { CoursesActions, ECoursesActions } from './courses.actions';
import { ICoursesState, initialCoursesState } from './courses.state';

export const coursesReducers = (
  state = initialCoursesState,
  action: CoursesActions
): ICoursesState => {
  switch (action.type) {
    case ECoursesActions.GetCoursesSuccess:
      return {
        ...state,
        courses: action.courses,
      };
    default:
      return state;
  }
};
